import Frtabs from 'fr-tabs/dist/frtabs.min';

class Tabs {
    constructor($tabs) {
        Frtabs({
            // String - Outer container selector, hook for JS init() method
            selector: '.tabs-wrap',

            // String - List selector to transform into tablist
            tablistSelector: '.tabs-list',

            // String - Containers which hold content, toggled via tabs
            tabpanelSelector: '.tabs-body',

            // String - Class name that will be added to the selector when the component has been initialised
            tabsReadyClass: 'tabs-ready'
        });

        [...$tabs].forEach($tabsWrap => {
            let $dropdown = $tabsWrap.querySelector('.js-tabs-dropdown');

            if ($dropdown) {
                $dropdown.addEventListener('change', e => {
                    document.getElementById($dropdown.value).click();
                });
            }
        });
    }
}

export default Tabs;
